import MoveAndRotate from "./moveAndRotate";

class MoveBranch extends MoveAndRotate {
    branchIdList;

    constructor(props) {
        super(props);
        this.branchIdList = props.branchIdList;
    }

    async stop() {
        this.cancelPendingMoveStepWait();
        changePerformMoveOnGroup(true);
        for (const branchId of this.branchIdList) {
            AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.TREE, branchId);
        }
        changePerformMoveOnGroup(false);
    }

    async execute() {
        changePerformMoveOnGroup(true);
        try {
            for (let branchId of this.branchIdList) {
                AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.TREE, branchId);
            }

            for (let i = 0; i < this.moveSteps.length; i++) {
            const volumeFinalMatrix = this.getComposedMatrix(i);

            let branchIdArray = [];
            for (let branchId of this.branchIdList) {
                const node = MeshHierarchyViewFeatureData.getDataFromBranchID(branchId);
                branchIdArray = node ? node.getLeaves() : [];
                if (branchIdArray.length > 0) {
                    break;
                }
            }

            if (branchIdArray.length > 0) {
                let volumeCurrentMatrix = new THREE.Matrix4();
                if (moved_volume_matrices[branchIdArray[0]]) {
                    volumeCurrentMatrix.copy(moved_volume_matrices[branchIdArray[0]]);
                }

                let applyMatrix = volumeFinalMatrix.clone();
                if (!this.transitionValues) {
                    // make the applyMatrix an offset or transition matrix to apply it on volume's current position and orientation
                    volumeCurrentMatrix.invert();
                    applyMatrix.multiply(volumeCurrentMatrix);
                    applyMatrix = getTransformationMatrixForVolumeExplosion(modelManager.getVolume(branchIdArray[0]), applyMatrix);
                }

                const pivot = this.getPivot(i);
                const animateTime = this.getAnimateTime(i);
                const animateMovement = animateTime > 0;
                for (let branchId of this.branchIdList) {
                    if (animateMovement) {
                        CADModelTransformationAnimationManager.transformVolumeWithAnimation(branchId, applyMatrix, undefined, animateTime, false, pivot);
                    } else {
                        CADModelTransformationAnimationManager.transformVolumeWithoutAnimation(branchId, applyMatrix);
                    }
                }

                if (animateMovement && i < this.moveSteps.length - 1) {
                    if (await this._waitMoveStep(animateTime + 20)) {
                        return;
                    }
                }
            }
        }
        } finally {
            changePerformMoveOnGroup(false);
        }
    }
}

export default MoveBranch;
